import React from 'react';
import ResourceLookupPage from 'pages/wholeme/molecules/resourceLookupPage/ResourceLookupPage';
import MainImage from 'pages/wholeme/molecules/mainImage/MainImage';
import appStrings from '../../../../../common/app_strings';
import { useAppState } from '../../../../../providers/app-state/app-state-provider';

const { wholeMe: { wholeMeSponsorIntake } } = appStrings;

const sponsorIntakePage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => {
  const { platform } = useAppState();

  return (
    <ResourceLookupPage
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      wholeMeClient={wholeMeClient}
      categoryId="sponsors"
      questionId="sponsors"
      title={wholeMeSponsorIntake.title}
      subtitle={wholeMeSponsorIntake.subtitle}
      dataFetcher={async () => (await wholeMeClient.fetchSponsorState())?.sponsors}
      dataSaver={wholeMeClient.saveSponsorState}
      resourceType="sponsors"
      resultAttributeId="sponsor"
      backgroundOverlay="/assets/overlays/two-circle-background-overlay.svg"
      isSingleValue
      exitIconOnClickOverride={exitIconOnClickOverride}
      minQueryLength={0}
      selectionRequired
      freeFormDisabled
      queryOnInputFocus
    >
      <MainImage
        imageSrc="./assets/icons/intake-pages/blue-semicircle-orange-triangle.svg"
        imageAlt="blue semicircle and orange triangle"
        imageStylesOverride={{
          width: platform?.isNativePlatform ? 'calc(100% - 80px)' : 'calc(45% - 80px)',
        }}
      />
    </ResourceLookupPage>
  );
};

export default sponsorIntakePage;
